import React, {useState, useEffect} from 'react';

import {ENumber, TNumber} from '@packages/systems/wfdl-ast';
import Hitarea from '@packages/systems/design-system/Hitarea';
import TextInput from '@packages/systems/design-system/TextInput';
import {TypeImplementation} from '@packages/systems/wfdl';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {
  timeInSecondsToSplitString,
  timeSplitStringToTimeInSeconds,
} from '@packages/systems/core/utils/TimeUtils';
import {
  type ContextualExpression,
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';

const defaultValue = 0;

const TimeNumberRender = ({
  expr,
  dispatch,
}: {
  expr: ContextualExpression;
  dispatch: TypeImplementation.ExpressionEditorDispatch;
}) => {
  const exprValue =
    ContextualExpressions.getNumber(stripAnn(expr)) || defaultValue;
  const [value, setValue] = useState(timeInSecondsToSplitString(exprValue));

  // sync input between settings panel and mini-settings
  useEffect(() => setValue(timeInSecondsToSplitString(exprValue)), [exprValue]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setValue(e.target.value);

  const onBlur = () => {
    // attempt to convert time string (e.g. '00:20') to seconds otherwise assign the default value
    const timeInSeconds =
      timeSplitStringToTimeInSeconds(value) || Number(defaultValue);
    setValue(timeInSecondsToSplitString(timeInSeconds));
    // save seconds as a number to Expression
    dispatch(updateExpressionAction(ENumber(timeInSeconds)));
  };

  return (
    <Hitarea>
      <TextInput
        type="text"
        placeholder={timeInSecondsToSplitString(defaultValue)}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
      />
    </Hitarea>
  );
};

export default TypeImplementation.Alias({
  type: TNumber,
  render: TimeNumberRender,
});
